import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    componentWillMount() {
        if (this.props.mode == 'keep' && !this.props.logged_in) {
            this.setState({
                show: true,
            });
        }
    }

    render({ mode, innerHTML, logged_in }) {
        if (!logged_in || this.state.show) {
            return (
                <logged-out mode={mode} dangerouslySetInnerHTML={{__html: innerHTML || ''}} />
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/logged-out.js